import type {DIContainerFactory} from '../../IoC/containerFactories/types';

import {ContainerBinder} from '../../IoC/ContainerBinder';
import {RequestPhoneNumberStore} from '../../modules/accounts/stores/RequestPhoneNumber/RequestPhoneNumber.store';
import {AppStoreReviewService} from './appStoreReview/AppStoreReview.service';
import {bindSystemCommon} from './bindSystem.common';

export const bindSystemApp: DIContainerFactory = ({
  containerToBind = ContainerBinder.createContainer(),
} = {}) => {
  bindSystemCommon(containerToBind);
  new ContainerBinder(containerToBind)
    .bindSingleton(AppStoreReviewService)
    .bindSingleton(RequestPhoneNumberStore);

  return containerToBind;
};
